import { useQuery } from "@tanstack/react-query";
import { fetchAllBranches } from "~/_legacy/apis/fetch-all-branches";

export const ALL_BRANCHES_QUERY_KEY = "allBranches";

export function useGetAllBranches() {
  return useQuery({
    queryKey: [ALL_BRANCHES_QUERY_KEY],
    queryFn: fetchAllBranches,
  });
}
